<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Material/Service Purchase Request Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Purchase Req. No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.requestno" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING" placeholder="Kosongkan, u/ pengisian otomatis"></b-form-input>
                            </b-input-group>
                        </b-col>
                         <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.requestdate" type="date" @change="tanggalBerubah" :state="!$v.model.requestdate.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-row>
                        <b-col>
                            <b-input-group >
                                <b-input-group-prepend><label>Requisition(MR) No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.mrequestno"></b-form-input>
                                <b-input-group-append v-if="!isEdit">
                                <b-btn text="Button" @click="lkuMRShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                            <b-input-group-prepend><label>Request Type</label></b-input-group-prepend>
                                <b-form-input v-show="isEdit" :value="model.jasa?'Service Request':'Material Request'" readonly></b-form-input>
                               <b-form-select v-show="!isEdit" v-model="model.jasa" :plain="true" :options="jasaMaterial" :state="!$v.model.jasa.$error"></b-form-select>
                                <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.barter" class="mt-1">BARTER</b-form-checkbox>
                            </b-input-group>
                        </b-col>                        
                    </b-row >    
                    <b-input-group>
                        <b-input-group-prepend><label>Internal Budget</label></b-input-group-prepend>
                        <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuBudgetShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>

                    <b-row align-h="between">
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>{{labelExpected}}</label></b-input-group-prepend>
                                <b-form-input v-model="model.expectreceipt" type="date" :state="!$v.model.expectreceipt.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group v-show="(model.jasa)">
                                <b-input-group-prepend><label>Expect.Service Finish</label></b-input-group-prepend>
                                <b-form-input v-model="model.jasafinish" type="date" :state="!$v.model.jasafinish.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-row align-h="between">
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>{{labelLocation}}</label></b-input-group-prepend>
                                <b-form-input v-model="model.locationdeliv"  placeholder="Delivery Location" :state="!$v.model.requestdate.$error"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-input v-model="model.remark" :state="!$v.model.remark.$error" placeholder="Note/Remark"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                    <b-input-group >
                        <b-input-group-prepend><label>CS Approver Div.</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.nextwf_username" placeholder="Select User !" v-b-tooltip.hover title="CS Approver Department/Division"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="addApprover()">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrdLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editOrdLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delOrdLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                        <b-row  align-h="center">
                            <b-col lg="6" xl="6" class="pl-0">
                                <b-input-group v-if="(model.ibudghdkey)">
                                        <b-input-group-prepend><label>Intern.Budget Line</label></b-input-group-prepend>
                                        <b-form-input v-model="ordLinesObj.budgetline" :state="!$v.ordLinesObj.ibudgdtkey.$error" readonly></b-form-input>
                                        <b-input-group-append >
                                        <b-btn text="Button" @click="lkuBudgetInternShow=true" >
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                        <b-form-checkbox v-model="ordLinesObj.ibudgdtkeyflag" value="YES" unchecked-value="NO"  class="ml-2 pt-2">NOT RELATED</b-form-checkbox>
                                </b-input-group>

                                <b-input-group>
                                    <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="ordLinesObj.iteminfo" @keyup.13.native="lkuItemShow=true" :state="!$v.ordLinesObj.itemno.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuItemShow=true" id="glAccount">
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                                    <b-input-group >
                                        <b-input-group-prepend><span class="p-2">Model/Type/Series</span></b-input-group-prepend>
                                        <b-form-input  v-model="model.typeseries" disabled></b-form-input>
                                    </b-input-group >
                                <b-input-group>
                                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                    <b-form-textarea :rows="3" :max-rows="10" v-model="ordLinesObj.description" :state="!$v.ordLinesObj.description.$error" ></b-form-textarea>
                                </b-input-group>
                                <b-form-row>
                                <b-col md="6">                            
                                    <b-input-group>
                                        <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                        <b-form-input v-model="ordLinesObj.quantity" type="number" v-bind:min="1"></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col md="6">                            
                                    <b-input-group>
                                        <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="ordLinesObj.unitsize"></b-form-input>
                                    </b-input-group>
                                </b-col>
                                </b-form-row >   
                                <b-form-row>
                                    <b-col lg="9" xl="6">                            
                                        <b-input-group>
                                            <b-input-group-prepend><span class="p-2">Estimate Unit price</span></b-input-group-prepend>
                                            <b-input-group-prepend>
                                            <span class="input-group-text">{{model.matauang}}</span>
                                            </b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" ></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-form-row >                      

                            </b-col>
                            <b-col lg="6" xl="5">
                                <v-dim :model="ordLinesObj" :key="updateDimDtl"></v-dim>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mt-1">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                    <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                    <b-input-group-append>
                                        <b-button class="btn btn-success mr-1" @click="saveOrdLines()">Update</b-button>
                                    </b-input-group-append>
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                        </b-card>
                    </template>  
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>         
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="6">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addOrdLines" >Add Request item</b-button>                          
                            <div class="ml-2">
                                Showing {{((ordLines.page - 1) * ordLines.limit + 1)}}
                                to <span v-if="((ordLines.page * ordLines.limit)>ordLines.total)">{{ordLines.total}}</span>
                                    <span v-else>{{ordLines.page * ordLines.limit}}</span>
                                <strong> of {{ordLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <!-- <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="ordLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="ordLines.total"
                            :per-page="ordLines.limit"
                            v-model="ordLines.page"
                        ></b-pagination>
                    </b-col> -->
                    <b-col cols="6">
                        <div style="float:right;">
                            <b-pagination 
                                align="right" size="sm"
                                :total-rows="ordLines.total"
                                :per-page="ordLines.limit"
                                v-model="ordLines.page"
                            ></b-pagination>
                        </div>
                        <div style="width:400px; text-align:right;float:right;padding-top:2px;">
                            <span class="mr-1">limit per page :</span> 
                            <input type="number" style="width:60px;" v-model="ordLines.limit"/>
                        </div>
                    </b-col>

                </b-row>
              </b-card>    
              <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group >
                            <b-input-group-prepend><label style="width: 170px !important;">Sugested Supplier/Vendor</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.vendorinfo"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuVendorShow=true" >
                                <i class="fa fa-search"></i>
                            </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:120px; padding-left:16px;">Estimated Total</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <b-form-select  v-model="model.matauang" :plain="true" :options="currency" ></b-form-select>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-row style="text-align: left !important;">
                                <b-col >
                                        <b-form-checkbox  v-model="model.chargeable" value=1 unchecked-value=0 style="margin-left:120px;">
                                        Chargeable to Customer
                                        </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
              </b-row>
            </b-form>
            <b-row class="justify-content-center mb-2">
                <!-- <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button> -->
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem" :jasa="`${model.jasa}`" isactive="1" :formdata="itemList"></lku-item>
        </b-modal>        
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Vendor" :centered="true">
            <lku-vendor @click="onSelectLkuVendor"></lku-vendor>
        </b-modal>    
         <b-modal v-model="lkuMRShow" size="lg" :hide-footer="true" title="List of APPROVED Material Request" :centered="true">
            <lku-mr @click="onSelectLkuMR" pr="0"  :filter='filterLkuMR'></lku-mr>
        </b-modal>        
        <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
            <lku-user @click="onSelectUser"></lku-user>
        </b-modal>        
        <!-- <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget Items" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>         -->
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Internal Budget" :centered="true">
            <lku-budgetinternal @click="onSelectLkuBudget"></lku-budgetinternal>
        </b-modal>        
        <b-modal v-model="lkuBudgetInternShow" size="lg" :hide-footer="true" title="Internal Budget Items" :centered="true">
            <lku-budgetinternalline @click="onSelectLkuBudgetIntern" :ibudghdkey="model.ibudghdkey" :formdata="lkuBudgetInternData" :key="model.ibudghdkey" ></lku-budgetinternalline>
        </b-modal>        
        <b-modal v-model="showNextwf" size="md" :hide-footer="true" header-bg-variant="primary" title="CS Approver from MR's Departement/Devision" :centered="true">    
                    <ol>
                        <li v-for="(approver,idx) in arrNextwf" :key="`approver-${idx}`">
                                {{approver.crewname}} 
                                <b-link @click="delApprover(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link>
                        </li>                
                    </ol>
                    <b-row class="justify-content-center mt-2">
                        <div style="width:200px;">
                            <b-input-group >
                                <b-input-group-append>
                                    <button size="sm"  class="btn btn-success mr-1" @click="lkuUserShow=true"><i class="fa plus-square"></i> Add Approver</button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <button size="sm" class="btn btn-danger mr-1" @click="showNextwf=false" > <i class="fa fa-close"></i> Close</button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-row>
        </b-modal> 

        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuBudgetinternal from "../lookup/lkuBudgetinternal";
import lkuBudgetinternalline from "../lookup/lkuBudgetinternallineLazzy";
import lkuItem from "../lookup/lkuItemSaldoLazzy";
import lkuCoa from "../lookup/lkuCoa";
import lkuVendor from "../lookup/lkuVendor";
import lkuMr from "../lookup/lkuMr";
import lkuUser from "../lookup/lkuUser";
import log_mr from "../../apis/logistic_mr";
import pr from "../../apis/logistic_pr";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim, lkuBudgetinternal,lkuBudgetinternalline, lkuItem,lkuCoa,lkuVendor,lkuMr, lkuUser},
  mixins: [validationMixin],
  validations: {
        model: {
            jasa: { required },
            requestdate: { required },
            expectreceipt: { required },
            jasafinish: { required:requiredIf('jasa') },
            remark: { required },
            locationdeliv: { required }
        },
        ordLinesObj: {
            ibudgdtkey: { required:(function() {
                if (this.model.ibudghdkey) {
                    if (this.ordLinesObj.ibudgdtkey) {
                        if (this.ordLinesObj.ibudghdkey=='N/A')
                            return true;
                        else {
                            if (this.model.ibudghdkey==this.ordLinesObj.ibudghdkey) {
                                return true;
                            } else {
                                toastr.error(`Budget Line not from Internal Budget`,'Line/Detail Expenses',10000);                                
                                return false;
                            }
                        }
                    } else return false;
                } else return true;
            }) },
            linetype: { required },
            itemno: { required },
            description: { required },
            quantity: { numeric, required }
        },
  }, 
  data() {
    return {
      inputBerlanjut: 1,
      inputLineBerlanjut: 1,
      isLoading: false,
      lkuBudgetShow:false,
      lkuBudgetInternShow: false,
        lkuBudgetInternData:{},
      lkuUserShow:false,
        saveEnabled:true,
        isEdit:false,
        lkuCoaShow:false,
        lkuItemShow:false,
        itemList:{},
        lkuVendorShow: false,
        lkuMRShow:false,
        filterLkuMR:{},
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        linetypes : [{ value: 1, text: 'Master Item ' },{ value: 3, text: 'GL Account' }],
        jasaMaterial : [{ value: 1, text: 'Service Request' }, { value: 0, text: 'Material Request' }],
        model:{
            jasa:0, matauang:this.$store.state.user.matauang, 
            requestno:'', 
        locationdeliv:this.$store.state.user.compaddr,ttlnetto:0, 
        requestdate: moment().format('YYYY-MM-DD'), ibudghdkey:'',budgetinfo:''},
        labelLocation:'Delivery Location',
        labelExpected:'Expected Delivery',
        ordLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Master Item",
                    thStyle: "width:240px",
                },
                {
                    key: "description",
                    label: "Description",
                    thStyle: "width:240px",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "nilai",
                    label: "Estimate Price",
                    thStyle: "width:110px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 20,
            total: 0,
        },
        ordLinesObj:{linetype:1,itemno:'', description:'', quantity:0, unitzise:'', ibudghdkey:'', ibudgdtkey:'',ibudgdtkeyflag:'YES' },
        arrNextwf:[],showNextwf:false
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidOrdLines() {
    //   this.ordLines.kenappn= (this.ordLines.ppn != 0); 
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    jasa(){
        return this.model.jasa;
    },
    unitprice(){
        return this.ordLinesObj.unitprice;
    },
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
    jasa: function(newval) {
        console.log('jasa newval',newval)
        this.filterLkuMR.jasa = newval;
        if (newval) {
            this.labelLocation='Service Location';
            this.labelExpected='Expected Start';
        } else {
            this.labelLocation='Delivery Location';
            this.labelExpected='Expected Delivery';
        }  
    },    
  },
  created: async function(){
    // this.currency = await pr.currency();

    if (this.$route.params.requestkey)  {
          
          try {
            this.isEdit = true;
            const data = await pr.detail(this.$route.params);  
            const row = data[0][0];
            if (row.isreject==1) row.send2wf=0;
            if (row.send2wf==1){
                if (row.isreviewed==1){
                    this.saveEnabled=true;
                } else {
                    this.saveEnabled=false;
                }
            }
            row.requestdate = row.requestdate ? moment(row.requestdate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            data[1].forEach((item,idx)=>{
                data[1][idx].budgetline = `${item.jccostname} ${item.jccostnote}`;
            });
            this.ordLines.items = data[1];
            this.model.terms = data[2];
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
            this.tanggalBerubah();
            const arrApprover = (this.model.nextwf_username||'').split(',');
            const arrApprovername = (this.model.nextwf_crewname||'').split(',');
            arrApprover.forEach((n,idx)=>{
                this.arrNextwf.push({username: n, crewname: arrApprovername[idx]});
            })
            this.updateDimHdr = !this.updateDimHdr;
            this.inputBerlanjut=0;
            this.$forceUpdate();                
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
    //   else {
    //     this.model.requestdate = moment().format('YYYY-MM-DD');  
    //   }
  },
  methods: {
    // onSelectLkuBudget: async function (_selected) {
    //     try {
    //         this.model.remark = _selected.uraian;
    //         this.model.budgetname = _selected.uraian;
    //         this.model.budgetnumber = _selected.nomorintern;
    //         this.model.jccostname = _selected.jccostname;
    //         this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
    //         this.model.nomorproduksi = _selected.noprodintern;
    //         this.model.ibudgdtkey = _selected.ibudgdtkey;
    //         this.model.ibudghdkey = _selected.ibudghdkey;
    //         this.model.pjxbudgkey = _selected.pjxbudgkey;
    //         this.model.pjxkey = _selected.pjxhdrkey;
    //         this.model.DimTableKey = _selected.pjxhdrkey;
    //         this.budgetbalance = _selected.ibbudgetamt -_selected.requestamt;

    //         this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format('YYYY-MM-DD') : '';
    //         this.dimension.forEach((dim) => {
    //             if (_selected[dim.value]) {
    //                 this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
    //             }
    //             if (dim.RelatedObj=='internalbudget') {
    //                 this.model[`${dim.value}`] = _selected.nomorintern;
    //                 this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
    //                 this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
    //             }
    //         });
    //         this.updateDimHdr=!this.updateDimHdr;

    //         this.lkuBudgetShow=false;
    //       } catch (error) {
    //             console.log('error : ', error);
    //             toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
    //       }
    // },
    onSelectLkuBudget: async function (_selected) {
        try {
            this.model.remark = _selected.uraian;
            this.model.budgetname = _selected.uraian;
            this.model.budgetnumber = _selected.nomorintern;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.uraian;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;
            this.model.DimTableKey = _selected.DimTableKey;

            this.model.expectreceipt = _selected.requstart ? moment(_selected.requstart).format('YYYY-MM-DD') : '';
            this.dimension.forEach((dim) => {
                if (_selected[dim.value]) {
                    this.model[dim.value] = _selected[dim.value];
                    this.model[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                    this.model[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
                }
                if (dim.RelatedObj=='internalbudget') {
                    this.model[`${dim.value}`] = _selected.nomorintern;
                    this.model[`${dim.value}Txt`] = _selected.uraian + ' # '+ _selected.noprodintern;
                    this.model[`${dim.value}Info`] = _selected.nomorintern + ' | '+ _selected.uraian + ' # '+ _selected.noprodintern;
                }
            });
            this.updateDimHdr=!this.updateDimHdr;

            this.lkuBudgetShow=false;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },
    onSelectLkuBudgetIntern: async function (ibLineObj) {
        try {
            this.ordLinesObj.jccostname = ibLineObj.selected.jccostname;
            this.ordLinesObj.budgetline = `${ibLineObj.selected.jccostname} ${ibLineObj.selected.jccostnote}`;
            this.ordLinesObj.ibudgdtkey = ibLineObj.selected.ibudgdtkey;
            this.ordLinesObj.ibudghdkey = ibLineObj.selected.ibudghdkey;
            this.ordLinesObj.ibudgdtkeyflag= 'NO';
            if (!(this.ordLinesObj.uraian))  this.ordLinesObj.uraian=this.ordLinesObj.budgetline;
            if (ibLineObj.selected.itemname) {
                this.ordLinesObj.itemno=ibLineObj.selected.itemno;
                this.ordLinesObj.itemname=ibLineObj.selected.itemname;
                this.ordLinesObj.iteminfo = ibLineObj.selected.partnumber.trim() + ' | ' + ibLineObj.selected.itemname.trim();
                this.ordLinesObj.partnumber = ibLineObj.selected.partnumber;
                this.ordLinesObj.invunitom = ibLineObj.selected.invunitom || ibLineObj.selected.unitsize ;
            }
            this.lkuBudgetInternShow=false;
            this.lkuBudgetInternData=ibLineObj;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    },

    closeOrdLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOrdLines : function () {
        this.closeOrdLines();
        const obj={_showDetails:true};
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        this.ordLinesObj.linetype=1;
        this.ordLinesObj.unitsize='EACH';
        this.ordLinesObj.quantity = 1;
        this.updateDimHdr2Dtl(this.ordLinesObj);
        this.ordLines.items.push(obj);
        this.ordLines.total=this.ordLines.items.length;
        setTimeout(() => {
            const bfore = this.ordLines.page;
            const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
            if (bfore != after){
                this.ordLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail PR',10000);
            }
        }, 100);    
        this.inputLineBerlanjut=1;
    },
    editOrdLines : function (obj,callback) {
        this.closeOrdLines();
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.ordLinesObj[dim.value] = obj[dim.value];
                this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.ordLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        this.inputLineBerlanjut=0;
        callback();
    },
    delOrdLines: function (index) {
        if (index > -1) {
            // this.ordLines.items.splice(index, 1);
            const posisi = (this.ordLines.page-1)*this.ordLines.limit;
            this.ordLines.items.splice(posisi+index, 1);
        }
        this.ordLines.total=this.ordLines.items.length;
        this.calcTotalDtlOrder();
    },
    saveOrdLines: async function (callback) {
        this.calcPrice();
        if (this.invalidOrdLines) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            let datadim=this.ordLinesObj;
            datadim.TableName = 'mr_sr_line';
            try {
                const dimValResult = await dimension.validate(datadim);
                if (dimValResult.success) {
                    for (var key in this.ordLinesObj) {
                        this.ordLines.selected[key] = this.ordLinesObj[key];
                    }
                    this.dimension.forEach((dim) => {
                        if (datadim[dim.value]) {
                            this.ordLines.selected[dim.value] = datadim[dim.value];
                            this.ordLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
                        }
                    });
                    this.ordLines.total=this.ordLines.items.length;
                    this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlOrder();
                    this.ordLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addOrdLines();
                        this.$v.ordLinesObj.$reset();                        
                    }
                } else {
                    var msg = dimValResult.message;
                    if (callback) callback(new Error(msg));
                    else {
                        toastr.error(msg, "ERROR MESSAGE",10000);
                    }
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    addApprover : function () {
        this.showNextwf = true;
        if (this.arrNextwf.length == 0) {
            setTimeout(() => {
                this.lkuUserShow = true;                
            }, 100);
        }
    },
    onSelectUser(_selected) {
        this.lkuUserShow=false;
        const ada =this.arrNextwf.find(a =>a.username == _selected.username);
        if (ada){
            toastr.error(`Approver "${_selected.full_name}" sudah ada dalam List`)
        } else {
            this.arrNextwf.push({username : _selected.username, crewname: _selected.full_name});
            this.model.nextwf_username = this.arrNextwf.map(a=> a.username).join(",");
            this.model.nextwf_crewname = this.arrNextwf.map(a=> a.crewname).join(",");
        }
    },

    delApprover : function (index) {
        if (index > -1) {
            this.arrNextwf.splice(index, 1);
        }
        this.model.nextwf_username = this.arrNextwf.map(a=> a.username).join(",");
        this.model.nextwf_crewname = this.arrNextwf.map(a=> a.crewname).join(",");
    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;
        } else {
            try {
                this.model.TableName = 'mr_sr_header';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    this.model.requestkey = this.model.requestkey || '';
                    this.model.requestno = this.model.requestno || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.requestdate = moment(row.requestdate).format('YYYY-MM-DD');
                    row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    if (this.model.jasa){
                        row.jasastart = row.expectreceipt;
                        row.jasafinish = row.jasafinish ? moment(row.jasafinish).format('YYYY-MM-DD') : undefined;
                    } else {
                        row.jasastart = undefined;
                        row.jasafinish = undefined;
                    }
                    let lineno=1;
                    row.lines = this.ordLines.items.reduce((newArr, item) => {
                        if ((item.itemno || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        // await pr.save(row);
                        // toastr.success("Complete successfully", "Save Request");
                        const hasil= await  pr.save(row);
                        this.isLoading=false;
                        toastr.success(`Success, Trx.Number ${hasil.requestno}`, "Save Purchase Request",10000);
                        // this.close();
                        // const filter = this.$store.state.filter;
                        // filter.prlist.tgl1= row.requestdate;
                        // filter.prlist.tgl2=row.requestdate;
                        // filter.prlist.sortBy='requestno';
                        // filter.prlist.sortDesc=true;
                        // this.$store.commit("filter", filter);
                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                this.model.ttlnetto=0
                                const keys = ['matauang','requestdate','locationdeliv','ttlnetto'];                        
                                for (var key in this.model) {
                                    if (keys.indexOf(key) == -1) {
                                      this.model[key] = '';
                                    }
                                }
                                this.ordLines.items=[];
                                this.ordLines.total=this.ordLines.items.length;
                                this.calcTotalDtlOrder();
                                this.$v.model.$reset();                        

                            }
                    } else {
                        toastr.error('Please fill at least 1(one) Request Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;            
                        this.isLoading=false;
                    }
                } else {
                    this.saveEnabled=true;            
                    this.isLoading=false;
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                }

            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    showLkuCoa() {
        if (this.ordLinesObj.linetype == 3) this.lkuCoaShow=true;
        else this.lkuItemShow=true;
    },
    onSelectLkuCoa(_selected) {
        this.ordLinesObj.iteminfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.ordLinesObj.partnumber = _selected.namaacc;
        this.ordLinesObj.itemno = _selected.kodeacc;
        this.ordLinesObj.itemname = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuItem(lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;

        this.ordLinesObj.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        // this.ordLinesObj.description =  lkuData.selected.itemname.trim() + ' | ' + lkuData.selected.partnumber.trim();
        this.ordLinesObj.partnumber = lkuData.selected.partnumber;
        this.ordLinesObj.itemno = lkuData.selected.itemno;
        this.ordLinesObj.itemname = lkuData.selected.itemname;
        this.ordLinesObj.unitsize= lkuData.selected.invunitom;
    },
    onSelectLkuVendor: async function (_selected) {
        this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendorNm = _selected.vendor_name;
        this.lkuVendorShow=false;
    },
    onSelectLkuMR: async function (_selected) {
        if(_selected.requestkey){
            this.lkuMRShow =  false;
            this.model.mrequestkey = _selected.requestkey;
            this.model.mrequestno = _selected.requestno;
            this.model.barter = _selected.barter || this.model.barter;
            
            this.model.jccostname = _selected.jccostname;
            this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
            this.model.nomorproduksi = _selected.noprodintern;
            this.model.ibudgdtkey = _selected.ibudgdtkey;
            this.model.ibudghdkey = _selected.ibudghdkey;
            this.model.pjxbudgkey = _selected.pjxbudgkey;
            this.model.pjxkey = _selected.pjxhdrkey;
            toastr.info('Loading Requisition Detail, please wait')
            const row = await log_mr.detail(_selected)
            const header = row[0][0];
             for (const key in header) {
                if (header.hasOwnProperty(key)) {
                      if (['requestkey','requestno','requestdate'].indexOf(key) == -1) {
                            this.model[key] = header[key];  
                      }
                }
            }
            this.model.expectreceipt = _selected.expectreceipt ? moment(_selected.expectreceipt).format('YYYY-MM-DD'):'';
            row[1].forEach((item,idx)=>{
                row[1][idx].unitsize = item.invunitom;
                row[1][idx].budgetline = `${item.jccostname} ${item.jccostnote}`;
                row[1][idx].mreqdtlkey = item.reqdtlkey;
            });
            
            this.ordLines.items = row[1];
            
            this.calcTotalDtlOrder();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            this.$forceUpdate();                
            toastr.clear;
        }
        // this.model.vendorinfo = _selected.vendor_name.trim() + ' | ' + _selected.vendor_code.trim();
        // this.model.vendor = _selected.vendor_code;
        // this.lkuVendorShow=false;
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.ordLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    calcPrice : function () {
        this.ordLinesObj.nilai = parseFloat(this.ordLinesObj.quantity) * parseFloat(this.ordLinesObj.unitprice);
        // if (this.ordLinesObj.disc > 0) {
        //     this.ordLinesObj.nilaidisc = this.ordLinesObj.disc * this.ordLinesObj.nilai / 100.0;
        // };
        // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
    },
    calcTotalDtlOrder: function () {
        let ttlnetto = 0;
        this.ordLines.items.forEach((trx)=> {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
    },

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'logistic.prform')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
